import type {ClientSchemaField} from 'registry/field/FieldTable';
import type {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import removeNulls from 'util/removeNulls';

/**
 * Converts a JSONScalar field array (e.g. `fieldsJson`, `allFieldsJson`)
 * into a typed field array, filtering out null entries that can appear in
 * persisted data. Accepts a nullable input for convenience at call sites.
 */
export function filterNullFields<T extends SchemaField | ClientSchemaField>(
  fieldsJson: null | undefined | Array<T | null | undefined>
): Array<T> {
  return fieldsJson ? removeNulls(fieldsJson) : [];
}
